// extracted by mini-css-extract-plugin
export var cardIcon = "_b0-5";
export var cardIconUnframed = "_b0-9";
export var checkboxCard = "_b0-0";
export var checkboxCardSelected = "_b0-4";
export var disabled = "_b0-2";
export var interactive = "_b0-1";
export var outerBorder = "_b0-3";
export var spacerMedium = "_b0-8";
export var spacerSmall = "_b0-7";
export var spacerXsmall = "_b0-6";